(() => {
  const root = document.querySelector("[data-rc-gift-date-cart]");
  if (!root) return;

  const listEl = root.querySelector("[data-rc-gift-list]");
  const addBtn = root.querySelector("[data-rc-gift-add]");
  const btn = root.querySelector("[data-rc-gift-save]");
  const statusEl = root.querySelector("[data-rc-gift-status]");
  const template = root.querySelector("[data-rc-gift-template]");
  const initialRaw = root.getAttribute("data-initial-reminders") || "";
  let rowCounter = 0;

  function setStatus(msg, isErr) {
    if (!statusEl) return;
    statusEl.textContent = msg || "";
    statusEl.style.color = isErr ? "#b42318" : "#2d6a4f";
  }

  function parseEntries(raw) {
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) return parsed;
      if (parsed && typeof parsed === "object") return [parsed];
    } catch (e) {
      // fall through
    }
    return [];
  }

  function normalizeEntry(entry) {
    return {
      recipient_name: String(entry?.recipient_name || "").trim(),
      event_date: String(entry?.event_date || "").trim(),
      occasion_label: String(entry?.occasion_label || "").trim(),
    };
  }

  function createRow(entry = {}) {
    if (!template || !template.content.firstElementChild) return null;
    const node = template.content.firstElementChild.cloneNode(true);
    const title = node.querySelector("[data-rc-gift-row-title]");
    const nameInput = node.querySelector("[data-rc-gift-name]");
    const dateInput = node.querySelector("[data-rc-gift-date]");
    const occasionInput = node.querySelector("[data-rc-gift-occasion]");
    const removeBtn = node.querySelector("[data-rc-gift-remove]");

    rowCounter += 1;
    node.dataset.rowIndex = String(rowCounter);
    if (title) title.textContent = `Loved one ${rowCounter}`;
    if (nameInput) nameInput.value = entry.recipient_name || "";
    if (dateInput) dateInput.value = entry.event_date || "";
    if (occasionInput) occasionInput.value = entry.occasion_label || "";

    removeBtn?.addEventListener("click", () => {
      const rows = listEl?.querySelectorAll("[data-rc-gift-row]") || [];
      if (rows.length <= 1) {
        if (nameInput) nameInput.value = "";
        if (dateInput) dateInput.value = "";
        if (occasionInput) occasionInput.value = "";
        setStatus("Keep at least one loved one on the list, or clear the fields.", false);
        return;
      }
      node.remove();
      renumberRows();
    });

    return node;
  }

  function renumberRows() {
    const rows = listEl ? Array.from(listEl.querySelectorAll("[data-rc-gift-row]")) : [];
    rows.forEach((row, idx) => {
      row.dataset.rowIndex = String(idx + 1);
      const title = row.querySelector("[data-rc-gift-row-title]");
      if (title) title.textContent = `Loved one ${idx + 1}`;
    });
    rowCounter = rows.length;
  }

  function hydrate() {
    const initial = parseEntries(initialRaw)
      .map(normalizeEntry)
      .filter((entry) => entry.recipient_name || entry.event_date || entry.occasion_label)
      .slice(0, 1);
    if (!listEl) return;
    listEl.innerHTML = "";
    if (initial.length) {
      initial.forEach((entry) => {
        const row = createRow(entry);
        if (row) listEl.appendChild(row);
      });
    } else {
      const row = createRow();
      if (row) listEl.appendChild(row);
    }
    renumberRows();
  }

  function collectRows() {
    const rows = listEl ? Array.from(listEl.querySelectorAll("[data-rc-gift-row]")) : [];
    const items = [];
    for (const row of rows) {
      const recipient_name = String(row.querySelector("[data-rc-gift-name]")?.value || "").trim();
      const event_date = String(row.querySelector("[data-rc-gift-date]")?.value || "").trim();
      const occasion_label = String(row.querySelector("[data-rc-gift-occasion]")?.value || "").trim();
      const isBlank = !recipient_name && !event_date && !occasion_label;
      const isPartial = Boolean(recipient_name || event_date || occasion_label) && (!recipient_name || !event_date);
      if (isBlank) continue;
      if (isPartial) {
        return {
          error: "Please complete each loved one with a name and date, or remove the blank row.",
          items: [],
        };
      }
      items.push({
        recipient_name,
        event_date,
        occasion_label,
      });
    }
    if (!items.length) {
      return {
        error: "Add at least one loved one before saving.",
        items: [],
      };
    }
    return { items, error: "" };
  }

  async function saveAttributes() {
    const result = collectRows();
    if (result.error) {
      setStatus(result.error, true);
      return;
    }

    const attrs = {
      rc_gift_reminders_json: JSON.stringify(result.items),
      rc_gift_special_name: result.items[0]?.recipient_name || "",
      rc_gift_special_date: result.items[0]?.event_date || "",
      rc_gift_special_label: result.items[0]?.occasion_label || "",
    };

    setStatus("Saving…", false);
    try {
      const res = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ attributes: attrs }),
      });
      if (!res.ok) {
        throw new Error(`HTTP ${res.status}`);
      }
      setStatus("Saved — we’ll remember these special dates with your order.", false);
    } catch (e) {
      setStatus("Could not save — please try again or continue to checkout.", true);
    }
  }

  addBtn?.addEventListener("click", (ev) => {
    ev.preventDefault();
    if (!listEl) return;
    const row = createRow();
    if (row) {
      listEl.appendChild(row);
      renumberRows();
      const input = row.querySelector("[data-rc-gift-name]");
      input?.focus();
      setStatus("Added another loved one.", false);
    }
  });

  if (btn) {
    btn.addEventListener("click", (ev) => {
      ev.preventDefault();
      saveAttributes();
    });
  }

  hydrate();
})();
